var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.31 41.2",
    style: {
      enableBackground: "new 0 0 47.31 41.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_393",
    fill: "#F6F6F6",
    cx: 22.02,
    cy: 20.6,
    r: 17.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69456",
    transform: "translate(-162.952 -229.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37241",
    d: "M201.77,257.11l-2.56-15.97c-0.06-0.36-0.37-0.62-0.73-0.62h-26.64c-0.37-0.02-0.7,0.24-0.76,0.6 l-2.52,14.57c-0.2,1.2,0.6,2.33,1.8,2.53c0.12,0.02,0.24,0.03,0.36,0.03h3.21c0.33,0.83,1.14,1.38,2.03,1.38h23.66 c1.21,0,2.19-0.99,2.19-2.2c0-0.11-0.01-0.23-0.03-0.34L201.77,257.11z M170.16,256.55c-0.14-0.17-0.2-0.39-0.17-0.6l1.83-10.5 l1.83,11.34h-2.93C170.51,256.79,170.3,256.71,170.16,256.55L170.16,256.55z M200.16,257.94L200.16,257.94 c-0.14,0.16-0.34,0.26-0.56,0.26h-23.65c-0.36,0-0.67-0.26-0.73-0.62l-2.49-15.59h25.13l2.45,15.37l0,0 C200.35,257.56,200.29,257.77,200.16,257.94L200.16,257.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37274",
    d: "M185.64,250.91h-3.06c-0.24,0.01-0.47-0.09-0.64-0.26c-0.39-0.25-0.49-0.77-0.24-1.16 c0.01-0.01,0.01-0.02,0.03-0.03c0.13-0.17,0.34-0.26,0.55-0.21h3.06l-0.55-3.06c-0.08-0.37,0.14-0.74,0.51-0.85h0.17 c0.5,0,0.93,0.36,1.02,0.85v0.04l0.55,2.98h3.02c0.49,0.01,0.9,0.37,0.98,0.85c0.1,0.37-0.13,0.75-0.5,0.85c0,0-0.01,0-0.01,0 c-0.09,0-0.13,0.04-0.21,0h-3.02l0.55,3.06c0.04,0.21,0,0.43-0.13,0.6c-0.31,0.33-0.83,0.34-1.16,0.03 c-0.01-0.01-0.02-0.02-0.03-0.03c-0.17-0.16-0.29-0.37-0.34-0.6L185.64,250.91z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOffer);
export default __webpack_public_path__ + "static/media/new-offer.ca4b1e2ffce15c2edf9fa16f9d7b3f68.svg";
export { ForwardRef as ReactComponent };